import styled from 'styled-components';

export const DepositPresetsStyled = styled.div`
    display: flex;
    gap: 8px;
    margin-top: 12px;
    overflow: auto;
    padding-bottom: 6px;
    
    &::-webkit-scrollbar {
        cursor: pointer;
        background: transparent;
        height: 5px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: var(--color-neutral-40);
        border-radius: 5px;
    }
`;

export const DepositRespawnTitleContainerStyled = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 12px;
    color: var(--color-white-95);
    
    svg {
        fill: var(--color-white-95);
    }
`;
